/** Single source of truth for Name / Address / Phone / hours (GBP live showroom). */
export const BUSINESS_NAP = {
  name: 'Harmony Jewels',
  streetAddress: '102 Hatton Garden',
  addressLocality: 'London',
  postalCode: 'EC1N 8LY',
  addressCountry: 'GB',
  /** Visible multi-line / inline address */
  addressDisplay: '102 Hatton Garden, London EC1N 8LY',
  addressDisplayMultiline: '102 Hatton Garden EC1N 8LY,\nLondon United Kingdom',
  telephone: '+44 7908 490125',
  telephoneHref: 'tel:+447908490125',
  email: 'sales@harmonyjewels.co.uk',
  url: 'https://www.harmonyjewels.co.uk/',
  image: 'https://d2o2k35fc1rqkh.cloudfront.net/assets/images/logo/logo-brand-white.svg',
  geo: {
    latitude: 51.5188725,
    longitude: -0.1081217
  },
  sameAs: [
    'https://www.facebook.com/harmonyjewelslondonuk',
    'https://www.instagram.com/harmonyjewelslondon/',
    'https://www.pinterest.co.uk/harmonyjewelslondon/_created/',
    'https://www.harmonyjewels.co.uk/'
  ],
  /** Mon–Sat 10:00–18:00 / Sun 10:00–16:00 */
  hoursWeekdayLine: 'Mon - Sat | 10:00 am - 6:00 pm',
  hoursSundayLine: 'Sun | 10:00 am - 4:00 pm',
  hoursSundayLineLong: 'Sunday | 10:00 am - 4:00 pm',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification' as const,
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '18:00'
    },
    {
      '@type': 'OpeningHoursSpecification' as const,
      dayOfWeek: ['Sunday'],
      opens: '10:00',
      closes: '16:00'
    }
  ]
} as const

export function buildLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'JewelryStore',
    name: BUSINESS_NAP.name,
    image: BUSINESS_NAP.image,
    '@id': BUSINESS_NAP.url,
    url: BUSINESS_NAP.url,
    telephone: BUSINESS_NAP.telephone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: BUSINESS_NAP.streetAddress,
      addressLocality: BUSINESS_NAP.addressLocality,
      postalCode: BUSINESS_NAP.postalCode,
      addressCountry: BUSINESS_NAP.addressCountry
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: BUSINESS_NAP.geo.latitude,
      longitude: BUSINESS_NAP.geo.longitude
    },
    openingHoursSpecification: [...BUSINESS_NAP.openingHoursSpecification],
    sameAs: [...BUSINESS_NAP.sameAs]
  }
}
